import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import style from "./style";
import { LoadingButton } from "@mui/lab";
import Modal from "../../components/Modal";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
const FringePage = ({
  // handleAllowance,
  fringes,
  loading,
  handleFringe,
  handleCreateFringe,
  handleDeleteFringe
  // setOpen,
  // setIsPaid,
  // isPaid,
  // updateLeaveType,
  // handleFringe,
}) => {
  const [allowanceText,setAllowanceText]=useState(false)
  // const [allowanceTax, setAllowanceTax] = useState(false);
  const [from, setFrom] = useState("");
  const [leave, setLeave] = useState("");
  // const [editleave, setEditleave] = useState("");
  const [open, setOpen] = useState(false);
  const [isPaid,setIsPaid]=useState(false)
  const [value, setValue] = useState();
  const [dltAllowance, setDelAllowance] = useState(false);
  const [allowanceTax, setAllowanceTax] = useState([
    { taxable: false },
    { taxable: true },
    // Add more items as needed
  ]);
    // const [checkbox,setCheckbox]=useState(false)
  const handleAddLeaveType = () => {
    setOpen(true);
    setFrom("create");
    setLeave("");
  };
  
  const deleteData = (item) => {
    setValue(item)
  }
  
  
  const handleDeleteItem = () => {
    handleDeleteFringe(value);
    setDelAllowance(false);
  };

  const handleInputChange = (id, value) => {
    setAllowanceText((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleTaxChange = (id) => {
    setAllowanceTax((prev) => ({
      ...prev,
      [id]: !prev[id], // Toggle the checkbox state for the specific item
    }));
  };

  return (
    <>
      <>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 ,mt:3,ml:3,mr:2}}>
          <Typography sx={style.gridText}>Fringe Benefits</Typography>
          <Button
            variant="contained"
            type="submit"
            color="success"
            sx={style.jobButtons}
            onClick={handleAddLeaveType}
          >
    + Add
          </Button>
        </Box>
        <Grid container sx={style.mainContainer}>
          {fringes?.map((allowanceItem, index) => (
            <Grid item xs={12} lg={3.5} sx={style.gridbox} key={index}>
              <Grid container sx={style.gridContiner}>
                <Grid item xs={12}>
                  <Box sx={style.inputSection}>
                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", mb: 0.5 }}>
                      <InputLabel sx={style.labels}>Fringe Benefit Type</InputLabel>
                      <DeleteOutlineIcon 
                        sx={{ ...style.delete, display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer", color: "#ff0000"  }}
                        onClick={() => { deleteData(allowanceItem?._id); setDelAllowance(true); }}
                      />
                    </Box>
                    <Box sx={style.selectGrid}>
                      <TextField
                        size="small"
                        value={allowanceText[allowanceItem?._id] ?? allowanceItem.name} 
                        onChange={(e) => handleInputChange(allowanceItem._id, e.target.value)}
                        sx={{ width: "100%", maxWidth: "280px" }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ ...style.inputSection, mb: 0.5 }}>
                    <FormControlLabel
                      sx={style.formControlLabel}
                      control={<Checkbox size="small"/>}
                      defaultChecked={allowanceItem?.isTaxable}
                      checked={allowanceTax[allowanceItem._id] ?? allowanceItem?.isTaxable}
                      onChange={() => handleTaxChange(allowanceItem._id)}
                      label="Is Taxable"
                    />
                  </Box>
                </Grid>
                <Box sx={{ ...style.btnSection, width: "100%", mt: 0.5 }}>
                  <LoadingButton
                    variant="contained"
                    size="small"
                    disabled={
                      (!allowanceText[allowanceItem._id]?.trim() || 
                      (allowanceText[allowanceItem._id] ?? allowanceItem.name) === allowanceItem.name) && 
                      (allowanceTax[allowanceItem._id] ?? allowanceItem.isTaxable) === allowanceItem.isTaxable 
                    }
                    onClick={() =>{
                      handleFringe(
                        allowanceText[allowanceItem._id] ?? allowanceItem.name, 
                        allowanceTax[allowanceItem._id] ?? allowanceItem.isTaxable,
                        allowanceItem._id
                      );setAllowanceText("")}
                    }
                    type="submit"
                    color="primary"
                    sx={style.submitButton}
                  >
                    Save
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          ))}
        </Grid>
        <Modal
          open={open}
          loading={loading}
          setOpen={setOpen}
          btnText={"Add New"}
          title={"Fringe Benefit Type"}
          handleCheck={() => {
            {handleCreateFringe(leave, isPaid),setOpen(false)}   
          }}
        >
          <Box sx={style.popupBox}>
            <Typography>
              {from === "edit" ? "Add Fringes Benefit Type" : "Add Fringes Benefit Type"}
            </Typography>
            <TextField
              sx={style.modalInput}
              name="leave"
              value={leave}
              onChange={(e) => setLeave(e.target.value)}
            />
            <FormControlLabel
              control={<Checkbox />}
              checked={isPaid}
              onChange={(e) => setIsPaid(e.target.checked)}
              label="Is Taxable"
            />
          </Box>
        </Modal>

        <Modal open={dltAllowance} setOpen={setDelAllowance} deletetText={"Delete"} cancelText={"Cancel"} title={"Delete Fringe Benefit Type "} handleDelete={handleDeleteItem}>
          <Box>
            <Typography>Are you sure you want to Delete?</Typography>
          </Box>
        </Modal>
      </>
    </>
  );
};

export default FringePage;
